export default {
  DISHES: (state) => state.dishes,
  DISH: (state) => state.dish,
};
